import { THREE} from 'three-edit-cores'
import { ConvexGeometry } from 'three/addons/geometries/ConvexGeometry.js';
import { PLYLoader } from 'three/examples/jsm/loaders/PLYLoader.js'
import {CustomMould} from '../../types/datatypes'

class Points extends CustomMould{
  create(_params,{scene}){
    Object.assign(this.params,_params.params)
     if(!this.params.url){
      this.params.url=window.prompt('点云ply文件地址')
     }
     if(!this.params.url){
      return
     }
    const loader = new PLYLoader()
       loader.load(this.params.url,geometry=>{
        // 计算顶点法线
        geometry.computeVertexNormals()
        //显示为点的方法
       const material = new THREE.PointsMaterial({ size: this.params.size, color: this.params.color})
       const points = new THREE.Points(geometry, material)
       scene.add(points)
       })
      return null
  }
}
const points=new Points('points','点云阵列')
points.params={
  size:5,
  color:'#fff',
  url:null
}
points.format={
      size:{name:'点云大小',domtype:'number',change(mesh,v){
          mesh.material.size=v
      }},
      color:{name:'点云颜色',domtype:'color',change(mesh,v){
        mesh.material.color=v
      }},
  }
export default points
